var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import React, { useLayoutEffect, useState } from 'react';
import { FlightButton } from '@flybits/design-system';
import '../../assets/styles/RuleBuilderSidePanel.scss';
import MultiplyIcon from '../../images/MultiplyIcon';
import { EVENT_KEYS } from '../../constants/event-keys';
export var RB_SIDE_PANEL_THEMES;
(function (RB_SIDE_PANEL_THEMES) {
    RB_SIDE_PANEL_THEMES["DEFAULT"] = "DEFAULT";
    RB_SIDE_PANEL_THEMES["EXTERNAL_APP"] = "EXTERNAL_APP";
})(RB_SIDE_PANEL_THEMES || (RB_SIDE_PANEL_THEMES = {}));
var RB_SIDE_PANEL_CLASS_NAMES = (_a = {},
    _a[RB_SIDE_PANEL_THEMES.DEFAULT] = {
        container: {
            mainClass: 'rule-builder-side-panel-container',
            modifier: '',
            animations: {
                fadeIn: 'rule-builder-side-panel-container--fade-in',
                fadeOut: 'rule-builder-side-panel-container--fade-out',
            },
        },
        panel: {
            mainClass: 'rule-builder-side-panel',
            modifier: '',
            animations: {
                slideIn: 'rule-builder-side-panel--slide-in',
                slideOut: 'rule-builder-side-panel--slide-out',
            },
        },
    },
    _a[RB_SIDE_PANEL_THEMES.EXTERNAL_APP] = {
        container: {
            mainClass: 'rule-builder-side-panel-container',
            modifier: 'rule-builder-side-panel-container--external-app',
            animations: {
                fadeIn: 'rule-builder-side-panel-container--fade-in-external-app',
                fadeOut: 'rule-builder-side-panel-container--fade-out-external-app',
            },
        },
        panel: {
            mainClass: 'rule-builder-side-panel',
            modifier: 'rule-builder-side-panel--external-app',
            animations: {
                slideIn: 'rule-builder-side-panel--slide-in',
                slideOut: 'rule-builder-side-panel--slide-out',
            },
        },
    },
    _a);
var SidePanel = function (_a) {
    var show = _a.show, _b = _a.theme, theme = _b === void 0 ? RB_SIDE_PANEL_THEMES.DEFAULT : _b, headerInfo = _a.headerInfo, footerInfo = _a.footerInfo, children = _a.children;
    var _c = __read(useState(false), 2), shouldRender = _c[0], setShouldRender = _c[1];
    useLayoutEffect(function () {
        if (show) {
            setShouldRender(true);
        }
    }, [show]);
    var onAnimationEnd = function () {
        if (!show) {
            setShouldRender(false);
        }
        else {
            /**
             * For focus trapping during keyboard navigation
             */
            // Start keyboard navigation focus from close button
            var closeButton_1 = document.querySelector('div.rule-builder-side-panel__header__close-btn-container');
            closeButton_1 === null || closeButton_1 === void 0 ? void 0 : closeButton_1.focus();
            var sidePanel_1 = document.querySelector('div.rule-builder-side-panel');
            // Move focus back to rb side panel when it goes out
            sidePanel_1.addEventListener('focusout', function (e) {
                var relatedTargetElement = e.relatedTarget;
                if (!(sidePanel_1 === null || sidePanel_1 === void 0 ? void 0 : sidePanel_1.contains(relatedTargetElement)) && !(relatedTargetElement === null || relatedTargetElement === void 0 ? void 0 : relatedTargetElement.closest('[tabIndex="-1"]'))) {
                    // Not so robust because it won't work
                    // if the rb side panel doesn't have a close button
                    closeButton_1 === null || closeButton_1 === void 0 ? void 0 : closeButton_1.focus();
                }
            });
        }
    };
    var title = headerInfo.title, icon = headerInfo.icon;
    var _d = footerInfo.primaryActionText, primaryActionText = _d === void 0 ? '' : _d, _e = footerInfo.primaryActionHandler, primaryActionHandler = _e === void 0 ? function () { return null; } : _e, _f = footerInfo.isPrimaryActionInProgress, isPrimaryActionInProgress = _f === void 0 ? false : _f, _g = footerInfo.secondaryActionText, secondaryActionText = _g === void 0 ? '' : _g, _h = footerInfo.secondaryActionHandler, secondaryActionHandler = _h === void 0 ? function () { return null; } : _h;
    return shouldRender ? (React.createElement("div", { className: "".concat(RB_SIDE_PANEL_CLASS_NAMES[theme].container.mainClass, " ").concat(RB_SIDE_PANEL_CLASS_NAMES[theme].container.modifier, " ").concat(show
            ? "".concat(RB_SIDE_PANEL_CLASS_NAMES[theme].container.animations.fadeIn)
            : "".concat(RB_SIDE_PANEL_CLASS_NAMES[theme].container.animations.fadeOut)) },
        React.createElement("div", { className: "".concat(RB_SIDE_PANEL_CLASS_NAMES[theme].panel.mainClass, " ").concat(RB_SIDE_PANEL_CLASS_NAMES[theme].panel.modifier, " ").concat(show
                ? "".concat(RB_SIDE_PANEL_CLASS_NAMES[theme].panel.animations.slideIn)
                : "".concat(RB_SIDE_PANEL_CLASS_NAMES[theme].panel.animations.slideOut)), "aria-labelledby": title, "aria-modal": true, role: "dialog", onAnimationEnd: onAnimationEnd },
            React.createElement("div", { className: "rule-builder-side-panel__header" },
                React.createElement("div", { className: "rule-builder-side-panel__header__title-container" },
                    React.createElement("div", { className: "rule-builder-side-panel__header__title-container__icon", "aria-label": "".concat(title, " icon") }, icon),
                    React.createElement("div", { className: "rule-builder-side-panel__header__title-container__title", "aria-label": title }, title)),
                React.createElement("div", { className: "rule-builder-side-panel__header__close-btn-container", role: "button", tabIndex: 0, "aria-label": "close rule side panel", onClick: secondaryActionHandler, onKeyDown: function (e) {
                        if (e.key === EVENT_KEYS.ENTER) {
                            secondaryActionHandler();
                        }
                    } },
                    React.createElement(MultiplyIcon, null))),
            React.createElement("div", { className: "rule-builder-side-panel__body" }, children),
            React.createElement("div", { className: "rule-builder-side-panel__footer" },
                React.createElement(FlightButton, { theme: "secondary", label: secondaryActionText, ariaLabel: secondaryActionText, onClick: secondaryActionHandler, onKeyDown: function (e) {
                        if (e.key === EVENT_KEYS.ENTER) {
                            secondaryActionHandler();
                        }
                    } }),
                React.createElement(FlightButton, { theme: "primary", label: primaryActionText, ariaLabel: primaryActionText, onClick: primaryActionHandler, onKeyDown: function (e) {
                        if (e.key === EVENT_KEYS.ENTER) {
                            primaryActionHandler();
                        }
                    }, loading: isPrimaryActionInProgress }))))) : null;
};
export var RuleBuilderSidePanel = React.memo(SidePanel);
//# sourceMappingURL=RuleBuilderSidePanel.js.map